import React from 'react'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Table from 'react-bootstrap/Table'
import moment from 'moment'
import Divider from './Divider'
import ReactGA from 'react-ga'
import MonetizationManager from '../managers/MonetizationManager'
import PollfishSurvey from './PollfishSurvey'
import {connect} from "react-redux"

class ConfirmationModal extends React.Component{ 

	constructor(props){
		super(props)
		this.state = { 
			survey: null, 
			surveyCompletionSent: false, 
			forceEnd: false
		}

		this.monetizationManager = new MonetizationManager(this.props.order.event.monetizations)
	}


	componentDidMount() {
		var hasPaidTicket = false
		for (var ticket of this.props.order.tickets) { 
			console.log(ticket)
			if (ticket.ticket_group.cost > 0) {
				hasPaidTicket = true
				break
			}
		}
		const survey = this.monetizationManager.getOptionalSurvey()
		if (survey !== null && hasPaidTicket == false) { 
			this.setState({survey: survey})
		}
	}

	getEventData() { 
		if (this.props.order == null) { 
			return null
		} else { 
			const event = this.props.order.event
			const time = moment(event.start_date).format('ddd MMM Do, h:mm a')
			return (<div>
						<p style={{fontWeight:'bold', fontSize: '20px', marginBottom:0}}>{event.title}</p>
						<p style={{marginBottom:0}}>{time}</p>
						<p>at {event.place}</p>
					</div>
				)
		}
	}

	handleClose() { 
		ReactGA.event({
			category: 'Booking',
			action: 'confirmation_close',
			label: 'redirect'
		})
		this.props.handleClose()
	}

	async handleCompletion(completion) { 
		const result = await this.monetizationManager.sendCompletion(completion)
		if (result == null) { 
			alert("Something went wrong. Try agian")
			return
		}
		this.setState({surveyCompletionSent: true})
	}

	handleClick(surveyData) { 
		if (surveyData !== null) {
			window.Pollfish.showFullSurvey()
		} else { 
			this.setState({forceEnd: true})
		}
	}

	handleDownloadClick(source) { 
		ReactGA.event({
			category: 'User',
			action: 'confirmation_download_click',
			label: 'ticket_conversion'
		})

		var url = null
		if (source === "ios") { 
			url = "https://itunes.apple.com/us/app/gameplan-plug-into-nightlife/id1448003243?ls=1&mt=8"
		} else { 
			url = "https://play.google.com/store/apps/details?id=com.victoranyirah.Gameplan"
		}

		window.location.href = url
	}

	getEmail() { 
		return this.props.appDomain === "witheta" ? "witheta.com" : "movement.fm";
	}

	getPrimaryView() { 
		console.log("SURVEY IS..")
		console.log(this.state.survey)
		// Knowingly removing plug for now.
		if (this.state.survey === null && false) { 
			return <div style={{ marginBottom: 20}}>
				<div style={{background: `url("/static/logo_background_title.jpg")`, width: '100%', height: 200,
				backgroundSize: 'cover', backgroundPosition: 'center', marginBottom: 20}}></div>
				<div style={{textAlign: 'center'}}>
					<h3>Get your ticket on the go.</h3>
					<p>Download the Movement app to have your tickets on hand and stay in the know about dope events
					happening around you curated by us.</p>
				<img src="../static/apple_app.svg" height="40" onClick={() => this.handleDownloadClick("ios")}/>
				<img src="../static/google-play-badge.png" height="60" onClick={() => this.handleDownloadClick("android")}/>
				</div>
				
			</div>
		} else {
			return <div style={{marginBottom: 20}}>
			</div>
		}
	}

	render() {
		return ( <Modal
			size="lg" 
			show={this.props.show} onHide={()=>this.handleClose()}>
		    <Modal.Header closeButton>
		      <Modal.Title>🎉 You're all set! 🎉</Modal.Title>
		      </Modal.Header>
		      <Modal.Body>
		      {this.getPrimaryView()}
				<h4>Summary </h4>
				<Divider style={{marginBottom:10}}/>	       
				{this.getEventData()}
		       <Table striped bordered hover>
	  				<thead>
	    			<tr>
	    				<th>Ticket Type</th>
	      				<th>First Name</th>
	      				<th>Last Name</th>
	    			</tr>
				  	</thead>
				  	<tbody>
				  	{this.props.order && this.props.order.tickets.map((item, index)=> 
				  		<tr>
				  		<td>{item.ticket_group.title}</td>
				  		<td>{this.props.order && this.props.order.first_name}</td>
				  		<td>{this.props.order && this.props.order.last_name}</td>

				  		</tr>
				  		)}
				  </tbody>
				</Table>

				<small>Confirmation Id: {this.props.order && this.props.order.id}</small>

				<p style={{fontWeight:'bold', marginTop:10}}>We've also sent you a confirmation email!</p>
				<p style={{fontWeight:'bold', marginTop:10}}>If you don't see it in your inbox please check your spam folder!</p>

		       <p>If you don't recieve an email with your ticket please feel free to shoot us an email
		       at <a href={"mailto:info@" + this.getEmail()}>{`info@${this.getEmail()}`}</a></p>

		      	<p>Download the Movement app to join the chat for this event plus see
		      	all the 🔥 things happening in your city curated by locals.</p>
		       
		       </Modal.Body>

		       <Modal.Footer>
		         <Button className="confirmation_close_btn" variant="primary" onClick={()=>this.props.handleClose()} block>
		          	Done
		         </Button>
		       </Modal.Footer>
       	 </Modal>)

	}
}

export default connect(state => state)(ConfirmationModal)